export default __webpack_public_path__ + "static/media/shopping-cart.2aaad2fe.svg";